// extracted by mini-css-extract-plugin
export default {"notifications":"NotificationManager_notifications__2e7dT","notification":"NotificationManager_notification__G+jc9","container":"NotificationManager_container__zOdqP"};